import * as React from 'react';

import { translate } from '~l10n/client';
import { Badge } from '~shared/components/Badge';

import {
  InsightsGenerateInsightsButton,
  useInsightsGenerateInsightsButton,
} from './InsightsGenerateInsightsButton';
import { InsightsGenerationBlockerDialog } from './InsightsGenerationBlockerDialog';
import { InsightsLearnMoreLink } from './InsightsLearnMoreLink';
import { InsightsBorderContainer } from './layout/InsightsBorderContainer';
import { InsightsFlexContainer } from './layout/InsightsFlexContainer';

interface InsightsNoneProps {
  activityInstanceId: number;
  showPaywall: boolean;
  setShowPaywall: (show: boolean) => void;
  averageScoreRate?: number | null;
}

export function InsightsNone({
  activityInstanceId,
  setShowPaywall,
  averageScoreRate,
}: InsightsNoneProps) {
  const {
    isLoading,
    onClickCapture,
    showNoInsightsDialog,
    setShowNoInsightsDialog,
  } = useInsightsGenerateInsightsButton({
    activityInstanceId,
    setShowPaywall,
    averageScoreRate,
  });

  return (
    <>
      <InsightsBorderContainer>
        <InsightsFlexContainer>
          <Badge textTransform="uppercase" tone="beta">
            {translate('Beta')}
          </Badge>
          <div className="flex-grow text-left text-blue-900 text-base font-400">
            <strong>{translate('AI Insights')}</strong>{' '}
            <span>
              {translate(
                'analyzes responses to see where participants can improve.'
              )}
            </span>{' '}
            <InsightsLearnMoreLink subheading="insightsFromResults" />
          </div>
          <div className="flex items-center gap-4 flex-shrink-0">
            <InsightsGenerateInsightsButton
              isLoading={isLoading}
              onClickCapture={onClickCapture}
            />
          </div>
        </InsightsFlexContainer>
      </InsightsBorderContainer>
      <InsightsGenerationBlockerDialog
        open={showNoInsightsDialog}
        onClose={() => setShowNoInsightsDialog(false)}
      />
    </>
  );
}
